import { PrimaryButton, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Prompt, useParams } from 'react-router-dom';
import WizardModeIndicator from '../../../../Util/WizardModeIndicator';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';
import ProgramForm from '../Components/ProgramForm';
import FeatureSummary from '../../../../Util/FeatureSummary';

const WizardPage = () => {
    const { coBrandID: coBrandIDFromParams } = useParams();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const [{ data: coBrandData, loading: cobrandLoading }, getCobrandProgramSettings] = useAxios(
        { url: `mindfulness-program/settings/${coBrandIDFromParams}`, method: 'GET' },
        { manual: true },
    );

    const [{ data: countries, loading: loadingCountries }] = useAxios('courses/countries');
    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: 'mindfulness-program/update-settings' },
        { manual: true },
    );

    useEffect(() => {
        if (coBrandIDFromParams && coBrandIDFromParams !== 'bulk') {
            getCobrandProgramSettings();
        }
    }, [coBrandIDFromParams]);

    if (cobrandLoading || loadingCountries) {
        return <Spinner className="absolute-center" text="Loading Cobrand Hub Settings..." />;
    }

    return (
        <>
            <WizardModeIndicator paramId={coBrandIDFromParams} title="Mindfulness Program" />
            <Formik
        initialValues={mapInitialValues({programData: coBrandData, countries: countries})}
            onSubmit={async (values, { resetForm }) => {
                let result;
                values.isGlobal && values.internationalOn ? values.includeCountries = [] : values.excludeCountries = [];
                result = await submitForm({
                    url: 'mindfulness-program/update-settings',
                    method: 'POST',
                    data: values,
                });
                resetForm({ values });

                if (!result.isAxiosError) {
                    setShowSuccess(true);
                } else {
                    setShowError(true);
                }
            }}
            isInitialValid={false}
        >
            {({ dirty, isValid, values, handleSubmit }) => {
                console.log({ dirty, isValid, values });
                return (
                    <>
                    {values &&
                        <Form style={{ maxWidth: '800px' }}>
                        <Prompt when={dirty} message="You have unsaved changes, are you sure you want to leave?" />

                        <div style={{ width: '100%' }} className="mt-1">
                            <ProgramForm model={values} />
                            <hr />
                            <div style={{ display: 'flex' }} className="mt-1">
                                <PrimaryButton
                                    onClick={() => handleSubmit()}
                                    text="Save"
                                    disabled={!dirty}
                                />
                            </div>
                        </div>
                        <SuccessComponent
                            successMessage="Program Settings Updated."
                            showSuccess={showSuccess}
                            setShowSuccess={setShowSuccess}
                        />
                        <ErrorComponent
                            errorMessage="Errors in form, check all tabs for highlighted fields."
                            showError={showError}
                            setShowError={setShowError}
                        />
                        <FeatureSummary
                            label="About Mindfulness Program"
                            summary="Configure mindfulness program settings for a specific cobrand. Set international targeting by including or excluding specific countries, and control the default on/off status for the mindfulness program feature."
                        />
                        <div></div>
                    </Form>
                    }
                    </>
                );
            }}
        </Formik>
        </>
    );
};

function mapInitialValues(data) {
    if (data.programData && data.countries) {
        return { ...data.programData,
            internationalOn: data.programData.internationalOn === true ? 1 : 0,
            onOffDefault: data.programData.onOffDefault === true ? 1 : 0,
            isGlobal: data.programData.internationalOn && data.programData.includeCountries.length === 0 ? 1 : 0,
            countries: data.countries.map(c => { return {value: c.id, label: c.name} })
        }
    }
}

export default WizardPage;
